import {
  SEARCH_KEY_QUERY_PARAM,
  SEARCH_QUERY_PARAM,
} from 'site-modules/shared/constants/personalized-search/personalized-search';
import { useEffect } from 'react';
import { PersonalizedSearchModel, PersonalizedSearchPaths } from 'client/data/models/personalized-search';

export function useSearchSubmit({ location, setModelValue }) {
  const key = location?.query?.[SEARCH_KEY_QUERY_PARAM];
  const query = location?.query?.[SEARCH_QUERY_PARAM]?.trim();

  useEffect(() => {
    if (!key && query) {
      setModelValue(PersonalizedSearchPaths.getLlmSearchSubmitParams(), PersonalizedSearchModel, query);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  useEffect(
    () => () => {
      setModelValue(PersonalizedSearchPaths.getLlmSearchSubmitParams(), PersonalizedSearchModel, '');
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
